import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1e287598"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top page-default page-media" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-search" }, null, -1))
const _hoisted_4 = ["placeholder", "onKeydown"]
const _hoisted_5 = {
  key: 0,
  class: "search-drop"
}
const _hoisted_6 = {
  key: 0,
  class: "part"
}
const _hoisted_7 = { class: "label" }
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = {
  key: 0,
  class: "btns"
}
const _hoisted_10 = {
  key: 0,
  class: "right c-thirdary"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "avatar signOut",
  src: _imports_0
}, null, -1))
const _hoisted_12 = {
  class: "link",
  style: {"margin-left":"10px"}
}
const _hoisted_13 = {
  key: 2,
  class: "mine-menu"
}
const _hoisted_14 = { class: "info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "avatar",
  src: _imports_0
}, null, -1))
const _hoisted_16 = {
  class: "c-primary",
  style: {"font-size":"16px"}
}
const _hoisted_17 = { class: "c-thirdary" }
const _hoisted_18 = { class: "options c-primary" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-tool-history" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-shoucang" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-pen" }, null, -1))
const _hoisted_22 = { class: "options c-primary" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gonggao" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-tool-history" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-tip" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-tuichudenglu1" }, null, -1))

import { RootState, showLogin } from '@/store';
import i18, { State as I18State } from '@/store/i18';
import channelSearch, { State } from '@/store/channels/search';
import user, { State as UserState } from '@/store/user';
import { computed, onMounted, reactive, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].movieTop)
const isHome = computed(() => route.path == '/lives' || route.path == '/lives/index.html')
const common = computed<RootState>(() => store.state)
const searchData = computed<State>(() => store.state[channelSearch.name])
const userData = computed<UserState>(() => store.state[user.name]);
const state = reactive({
    search: '',
    mineMenuVisible: false,
    lastRoute: '',
    searchHistory: [] as string[],
    searchHistoryVisible: false
})

onMounted(() => {
    state.search = searchData.value.keywords
    let s = window.localStorage.getItem('search')
    if (s) {
        try {
            state.searchHistory = JSON.parse(s)
        } catch (e) {
        }
    }
})

watch(() => searchData.value.keywords, () => {
    state.search = searchData.value.keywords
})

function showMineMenu() {
    state.mineMenuVisible = true;
    document.onmousedown = function () {
        document.onmousedown = null;
        state.mineMenuVisible = false;
    }
}

function onFocusSearch() {
    state.searchHistoryVisible = true
}

function onBlurSearch() {
    state.searchHistoryVisible = false
}

function doSearch() {
    if (state.search) {
        if (state.searchHistory.indexOf(state.search) == -1) {
            state.searchHistory.unshift(state.search)
            if (state.searchHistory.length > 3) {
                state.searchHistory.pop()
            }
            window.localStorage.setItem('search', JSON.stringify(state.searchHistory))
        }
        let type = searchData.value.type
        if (route.name != 'channel-search') {
            type = 'channel'
        }
        router.push({
            name: 'channel-search',
            params: {
                type: type,
                kw: state.search
            }
        })
    }
}

function onSelectedWord(value: string) {
    state.search = value
    doSearch()
}

function clearSearchHistory() {
    window.localStorage.removeItem('search')
    state.searchHistory = []
}

function doLogin() {
    showLogin(store)
}

function doShare() {

}

function doLogout() {
    user.logout(store);
    router.push('/')
}

function doGo(path: string) {
    router.push(path)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search) = $event)),
        placeholder: _unref(lang).search_placeholder,
        onFocus: onFocusSearch,
        onBlur: onBlurSearch,
        onKeydown: _withKeys(doSearch, ["enter"])
      }, null, 40, _hoisted_4), [
        [_vModelText, _unref(state).search]
      ]),
      _createElementVNode("a", {
        class: "search-btn",
        onClick: doSearch
      }, _toDisplayString(_unref(lang).search), 1),
      (_unref(state).searchHistoryVisible && _unref(state).searchHistory.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(state).searchHistory.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_unref(lang).search_history), 1),
                    _createElementVNode("a", { onMousedown: clearSearchHistory }, _toDisplayString(_unref(lang).search_clear), 33)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).searchHistory, (item) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "hot",
                      onMousedown: ($event: any) => (onSelectedWord(item))
                    }, _toDisplayString(item), 41, _hoisted_8))
                  }), 256))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_unref(isHome))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/lives",
            class: "value icon i-home",
            style: {"font-size":"26px"}
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(common).moviesConfig.ucenter)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(userData).info)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("img", {
                  class: "avatar",
                  onClick: showMineMenu,
                  src: _imports_0
                })
              ]))
            : _createCommentVNode("", true),
          (!_unref(userData).info)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "right c-thirdary",
                onClick: doLogin
              }, [
                _hoisted_11,
                _createElementVNode("a", _hoisted_12, _toDisplayString(_unref(lang).login), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(userData).info && _unref(state).mineMenuVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(userData).info.nickname), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(userData).info.username), 1),
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: "c-app",
                onMousedown: _cache[1] || (_cache[1] = ($event: any) => (doGo('/mine')))
              }, _toDisplayString(_unref(lang).my_profile), 33)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[2] || (_cache[2] = ($event: any) => (doGo('/mine/playbacks')))
            }, [
              _hoisted_19,
              _createTextVNode(_toDisplayString(_unref(lang).my_play), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[3] || (_cache[3] = ($event: any) => (doGo('/mine/favorites')))
            }, [
              _hoisted_20,
              _createTextVNode(_toDisplayString(_unref(lang).my_favorite), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[4] || (_cache[4] = ($event: any) => (doGo('/mine/notes')))
            }, [
              _hoisted_21,
              _createTextVNode(_toDisplayString(_unref(lang).my_note), 1)
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[5] || (_cache[5] = ($event: any) => (doGo('/mine/news')))
            }, [
              _hoisted_23,
              _createTextVNode(_toDisplayString(_unref(lang).notices), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[6] || (_cache[6] = ($event: any) => (doGo('/mine/about')))
            }, [
              _hoisted_24,
              _createTextVNode(_toDisplayString(_unref(lang).about), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[7] || (_cache[7] = ($event: any) => (doGo('/mine/suggest')))
            }, [
              _hoisted_25,
              _createTextVNode(_toDisplayString(_unref(lang).suggest), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: doLogout
            }, [
              _hoisted_26,
              _createTextVNode(_toDisplayString(_unref(lang).quit), 1)
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})